import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { JobVacancyService } from './job-vacancy/job-vacancy.service';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs';
import { FeedbackComponent } from '../../components/feedback/feedback.component';
@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss'],
  standalone: true,
  imports: [SharedModule, RouterLink, FeedbackComponent],
})
export class CareersComponent implements OnInit {
  @ViewChild('form')
  form!: NgForm;
  formCliente: FormGroup;
  sendedMail!: boolean;
  clickedButton!: boolean;
  acceptedTerms: boolean = false;
  file!: any;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private jobVacancyService: JobVacancyService
  ) {
    this.formCliente = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      candidacy: ['', Validators.required],
      msg: ['', Validators.required],
      file: ['', Validators.required],
      linkedIn: ['', Validators.required],
      acceptedTerms: [null, Validators.requiredTrue],
    });
  }

  ngOnInit() {}

  send() {
    this.isLoading = true;
    const form = new FormData();
    form.append('name', this.formCliente.get('name')?.value);
    form.append('email', this.formCliente.get('email')?.value);
    form.append('phone', this.formCliente.get('phone')?.value);
    form.append('candidacy', this.formCliente.get('candidacy')?.value);
    form.append('msg', this.formCliente.get('msg')?.value);
    form.append('linkedIn', this.formCliente.get('linkedIn')?.value);
    form.append('file', this.file);

    this.jobVacancyService
      .sendJobVacancy(form as any)
      .pipe(take(1))
      .subscribe({
        next: () => (
          (this.sendedMail = true),
          (this.clickedButton = true),
          (this.isLoading = false)
        ),
        error: () => (
          (this.sendedMail = false),
          (this.clickedButton = true),
          (this.isLoading = false)
        ),
        complete: () => (
          this.form.resetForm(), this.removeDocument(), (this.isLoading = false)
        ),
      });
  }

  csvInputChange(fileInputEvent: any) {
    this.file = fileInputEvent.target.files[0];
  }
  checkbox(): void {
    this.acceptedTerms = !this.acceptedTerms;
  }
  removeDocument(): void {
    this.formCliente.get('file')?.patchValue(null);
    this.file = null;
  }
}
